import React, {useState} from 'react';
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";
import Row from "../../UI/Row";
import {formatDate} from "../../../utilities/formatter";
import {FaChevronDown, FaChevronUp} from "react-icons/fa";

const Entry = ({subscription}) => {

    const {subscription: sub} = useDashboard();

    return (
        <div
            className="flex flex-col md:flex-row gap-1 md:items-center justify-between p-1 bg-gray-100 even:bg-gray-200 bg-opacity-10 even:bg-opacity-20">
            <div>
                <div className="leading-none font-medium text-ea_yellow">{subscription.subscription.name}</div>
                {sub && sub.id === subscription.id && <div className="text-xs text-ea_yellow">Abbonamento corrente</div>}
                {subscription && subscription.users_addons && subscription.users_addons.length > 0 &&
                <div className="flex flex-row items-center gap-1 text-xs">
                    <div className="">Pacchetti aggiuntivi:</div>
                    <div className="flex flex-row items-center gap-1 flex-wrap">
                    {subscription.users_addons.map((item, i) => <div key={i} className="uppercase font-medium">{item.name}</div>)}
                    </div>
                </div>
                }
            </div>
            <div className="flex flex-row justify-between md:flex-col">
                <Row className="gap-1 text-xs">
                    <div>INIZIO</div>
                    <div>{formatDate(subscription.start_date)}</div>
                </Row>
                <Row className="gap-1 text-xs">
                    <div>FINE</div>
                    <div>{formatDate(subscription.deadline)}</div>
                </Row>
            </div>

        </div>
    );
}

const History = () => {

    const {history} = useDashboard();

    const [expiredVisible, setExpiredVisible] = useState(false);
    const [futureVisible, setFutureVisible] = useState(false);

    return (
        <div className="text-left">
            {history.expired && history.expired.length > 0 &&

            <div className="mb-8">
                <Row className="justify-between border-b cursor-pointer"
                     onClick={() => setExpiredVisible(!expiredVisible)}>
                    <button className=" text-sm">
                        STORICO ABBONAMENTI
                    </button>
                    {expiredVisible ?
                        <FaChevronUp/>
                        : <FaChevronDown/>
                    }
                </Row>

                {expiredVisible &&
                <div className="border">
                    {history.expired && history.expired.length > 0 ?
                        history.expired.map((hist, i) => <Entry subscription={hist} key={i}/>)
                        :
                        <div className="p-2 italic text-gray-400">Nessun abbonamento in storico</div>
                    }
                </div>
                }
            </div>
            }

            {history.not_expired && history.not_expired.length > 0 &&
            <div>
                <Row className="justify-between border-b cursor-pointer"
                     onClick={() => setFutureVisible(!futureVisible)}>
                    <button className=" text-sm">
                        ABBONAMENTI VALIDI
                    </button>
                    {futureVisible ?
                        <FaChevronUp/>
                        : <FaChevronDown/>
                    }
                </Row>

                {futureVisible &&
                <div className="border">
                    {history.not_expired && history.not_expired.length > 0 ?
                        history.not_expired.map((hist, i) => <Entry subscription={hist} key={i}/>)
                        :
                        <div className="p-2 italic text-gray-400">Nessun abbonamento usufruibile</div>
                    }
                </div>
                }
            </div>
            }

        </div>
    );
};

export default History;
